import { mix, lighten } from './colorUtils';

export const BRAND_ACCENT = '#1a73e8';

export function getTokens(mode) {
  const accent = BRAND_ACCENT;
  if (mode === 'dark') {
    return {
      pageBg: mix(accent, '#05060a', 0.90),
      panel: mix(accent, '#0a0b10', 0.82),
      card: mix(accent, '#0d0e14', 0.88),
      border: mix(accent, '#1a1b22', 0.85),
      chipBg: mix(accent, '#1a1b22', 0.78),
      planBadgeBg: mix(accent, '#0d0e14', 0.70),
      text: '#f5f4f7',
      muted: '#9a97a3',
      mutedFaint: '#615e6a',
      okBg: mix('#34d399', '#0d0e14', 0.75),
      okText: '#34d399',
      warnBg: mix('#f5a623', '#0d0e14', 0.72),
      warnText: '#f5a623',
      dangerBg: mix('#f87171', '#0d0e14', 0.75),
      dangerText: '#f87171',
      cardShadow: '0 0 0 1px rgba(255,255,255,0.05), 0 16px 34px -18px rgba(0,0,0,0.7)',
    };
  }
  return {
    pageBg: mix(accent, '#ffffff', 0.97),
    panel: mix(accent, '#ffffff', 0.93),
    card: '#ffffff',
    border: mix(accent, '#ffffff', 0.84),
    chipBg: mix(accent, '#ffffff', 0.90),
    planBadgeBg: mix(accent, '#ffffff', 0.86),
    text: '#15131a',
    muted: '#6b6873',
    mutedFaint: '#a19dab',
    okBg: '#d7f3e6',
    okText: '#0d7a4c',
    warnBg: '#fdeccb',
    warnText: '#96650b',
    dangerBg: mix('#ef4444', '#ffffff', 0.88),
    dangerText: '#b91c1c',
    cardShadow: '0 0 0 1px rgba(20,15,30,0.03), 0 10px 24px -14px rgba(20,15,30,0.16)',
  };
}

export function accentText(mode) {
  return mode === 'dark' ? lighten(BRAND_ACCENT, 30) : BRAND_ACCENT;
}
